import React, {Component} from 'react';

import './styles/widget.scss';
import {bindActionCreators} from "redux";
import {changeTypeOfModal, openModal, saveModalInfo} from "../../actions/modals";
import {connect} from "react-redux";
import Cookies from 'js-cookie';

class Widget extends Component {

    timerId;
        
    componentDidMount() {
        if(this.props?.data)
            this.checkOpenForm();
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevProps && this.props?.data)
            this.checkOpenForm();
    }

    checkOpenForm() {
        let showByTimer = false;
        let showAfterSec = this.props.data?.time_sec_before_form_open ?? 0;       
        let formPassed = Cookies.get(`widget_${this.props.data.widget_type}_passed`);
        if(!formPassed && showAfterSec) {
            showByTimer = true;
            let showAfterHours = this.props.data?.next_show_hours;
            let lastShow = Cookies.get(`widget_${this.props.data.widget_type}_last_show`);
            if(showAfterHours && lastShow) {
                let nextShow = new Date(+lastShow);
                lastShow = new Date(+lastShow);
                nextShow.setHours(lastShow.getHours() + showAfterHours);
                let now = new Date();
                if(nextShow > now)
                    showByTimer = false;     
            }
        }

        if(showByTimer) {
            this.timerId = setTimeout(this.openForm.bind(this), showAfterSec*1000);
        }
    }
    
    openForm() {
        let formParams = {
            widgetType: this.props.data.widget_type,
            widgetSlug: this.props.data.widget_slug,
            totalWheelSectorAmount: this.props.data.total_wheel_sector_amount,
            title: this.props.data.form.title,
            text: this.props.data.form.text,
            image: this.props.data.form.image,
            buttonCaption:this.props.data.form.button_caption,
            widgetActiveUntil: this.props.data.active_until, //for cookie expire
            successTitle: this.props.data.form.success_title,
            successText: this.props.data.form.success_text,
            successImage: this.props.data.form.success_image,
            failTitle: this.props.data.form.fail_title,
            failText: this.props.data.form.fail_text,
            discounts: this.props.data.discounts,
            image_submit_animation: this.props.data.form.image_submit_animation,
            winPresentLabel: this.props.data.form.win_present_label,
            winPresentLabelPlace: this.props.data.form.win_present_label_place,
            winExistsTitle: this.props.data.form.win_exists_title
        }

        this.props.saveModalInfo(formParams);
        this.props.changeTypeOfModal('widgetForm');
        this.props.openModal();

        if (this.timerId)
            clearTimeout(this.timerId);
    }

    render() {
        return(
            <div className={`widget-container ${this.props.data?.widget_slug ?? ''} ${this.props.data?.trigger_animation ?? ''} ${this.props.data?.trigger_position ?? 'right-bottom'}`}
                 onClick={this.openForm.bind(this)}
                 style={{backgroundImage: `url('${this.props.data.trigger_image}')`}} >
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            openModal,
            changeTypeOfModal,
            saveModalInfo
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(Widget);

